import { render, staticRenderFns } from "./EmbedSection.vue?vue&type=template&id=3c1dd590&"
import script from "./EmbedSection.vue?vue&type=script&lang=js&"
export * from "./EmbedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports